import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Row, Col, Dropdown, Form } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";
import {
  getUserInfo,
  logoutUser,
  getUserInfoByEmail,
  redirectToLogout,
  setUserData,
  checkIsUpdated,
  redirectToLogin,
} from "../../store/actions/auth/authActions";
import ChangePasswordModal from "../modal/changePassword";

import { Cache } from "aws-amplify";

class Header extends Component {
  constructor(props) {
    super(props);
    this.defaultRole = "";
  }

  async componentDidMount() {
    let userData = Cache.getItem("userdata");

    if (
      !userData ||
      !userData.family_name ||
      !userData.given_name ||
      userData.userDetails !== null
    ) {
      setUserData();
    }
  }

  // Add state for managing the modal visibility
  state = {
    isChangePasswordModalVisible: false,
  };

  // Function to open the Change Password modal
  openChangePasswordModal = () => {
    this.setState({ isChangePasswordModalVisible: true });
  };

  // Function to close the Change Password modal
  closeChangePasswordModal = () => {
    this.setState({ isChangePasswordModalVisible: false });
  };

  getRoles = () => {
    const roles = [];
    const roleId = Cache.getItem("roleId");
    let rolesOption, firstRole;
    if (typeof roles !== "undefined") {
      rolesOption =
        roles.length &&
        roles.map((role, key) => {
          if (key === 0) {
            firstRole = role;
          }

          if (roleId && roleId === role.id) {
            this.defaultRole = role;
          }

          return (
            <option key={key} value={role.id}>
              {role.role_name}
            </option>
          );
        });
    }

    if (!this.defaultRole) {
      this.defaultRole = firstRole;
    }

    return rolesOption;
  };

  render() {
    const userData = Cache.getItem("userdata");
    // console.log(userData);

    const fullName =
      userData && userData.family_name
        ? userData.family_name + ", " + userData.given_name
        : "";

    return (
      <Row id="app-title" className="align-left">
        <Col xs={9} sm={9} md={9} lg={9} xl={9}></Col>
        <Col xs={3} sm={3} md={3} lg={3} xl={3}>
          <Dropdown alignRight id="user-burger-menu">
            <Dropdown.Toggle id="user-burger-menu_button">
              {fullName}
            </Dropdown.Toggle>
            <Dropdown.Menu
              id="user-burger-menu-dropdown"
              className="super-colors"
            >
              <Dropdown.Item onClick={this.openChangePasswordModal}>
                <FontAwesomeIcon icon={faLock} flip="horizontal" /> Change
                Password
              </Dropdown.Item>
              <Dropdown.Item
                onClick={() => {
                  localStorage.clear();
                  Cache.clear();
                  redirectToLogin();
                }}
              >
                <FontAwesomeIcon icon={faSignOutAlt} flip="horizontal" /> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </Col>

        {/* Render the Change Password modal */}
        <ChangePasswordModal
          isOpen={this.state.isChangePasswordModalVisible}
          onRequestClose={this.closeChangePasswordModal}
        />
      </Row>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Header));
